import * as actionsTypes from './../types/menuTypes'
import axios from 'axios'

export const fetchMenuRequest = () => {
    return {
        type: actionsTypes.FETCH_MENU_REQUEST,
    }
}

export const fetchMenuSuccess = (menu) => {
    return {
        type: actionsTypes.FETCH_MENU_SUCCESS,
        payload: menu
    }
}

export const fetchMenuFailure = (error) => {
    return {
        type: actionsTypes.FETCH_MENU_FAILURE,
        payload: error
    }
}

export const fetchMenu = (location) => {
    return function (dispatch) {
        dispatch(fetchMenuRequest())
        axios.get(process.env.REACT_APP_API_URL + location + '/menu.json')
            .then(response => {
                const menu = response.data
                dispatch(fetchMenuSuccess(menu))
            })
            .catch(error => {
                dispatch(fetchMenuFailure(error))
            })
    }
}